// Salsify Enhanced Content Integration
window.salsifyExperiencesSdkLoaded = salsify => {
  // Initialize the SDK
  salsify.init({
    clientId: "s-e442ae42-1eee-411a-a4de-c55bc2b5bd52", // enter the client id
    tracking: false,
    languageCode: "en-US", // enter the locale code
    enhancedContent: {
      idType: "SKU" // enter the product identifier type
      
    }
  });

  /**
   * Renders Salsify enhanced content for a product if available
   * @param {string} productID - The product ID to render content for
   * @returns {Promise<void>}
   */
  async function renderEnhancedContent(productID) {
    if (!productID) return;

    const ecContainer = document.getElementById("salsify-ec-container");
    
    if (!ecContainer) return;

    try {
      
      const ecExists = await salsify.enhancedContent.exists(productID, "SKU"); // enter the product identifier type
   
  
      console.log(productID);
      if (ecExists) {
        salsify.enhancedContent.renderIframe(ecContainer, productID, "SKU"); // enter the product identifier type
          

          
        console.log('the enhanced content exist');
      } else {
        console.log('product not found');
      }
    } catch (error) {
      console.error('Error rendering Salsify enhanced content:', error);
      ecContainer.style.display = 'none';
    }
    
  }

  // Expose the render function globally
  window.renderSalsifyContent = renderEnhancedContent;
 
};
